import React from 'react';
import PragroupLegal from './PragroupLegal';

const UPDATED = 'Last updated: February 17, 2026';

export default function Compliance() {
  return (
    <PragroupLegal badge="Regulatory" title="Compliance" updated={UPDATED}>
      <div className="pg-legal-section">
        <h2>1. Our Commitment</h2>
        <p>PRA Group is committed to operating in full compliance with applicable laws and regulations governing cryptocurrency and digital asset services. We maintain rigorous internal controls and partner with leading compliance firms to ensure the integrity of our platform.</p>
      </div>
      <div className="pg-legal-section">
        <h2>2. Know Your Customer (KYC)</h2>
        <p>All users must complete identity verification before accessing trading, exchange, or withdrawal services. Our KYC process includes government-issued photo ID verification, proof of residential address, biometric facial recognition matching, and enhanced due diligence for high-risk profiles.</p>
        <p>Verification is typically completed within 24 hours. We use secure, encrypted channels for all document submissions.</p>
      </div>
      <div className="pg-legal-section">
        <h2>3. Anti-Money Laundering (AML)</h2>
        <p>Our AML program is designed to detect and prevent money laundering, terrorist financing, and other financial crimes. Key components include real-time transaction monitoring with automated risk scoring, suspicious activity reporting (SAR) to relevant authorities, ongoing monitoring of customer activity and risk profiles, regular staff training on AML obligations, and sanctions screening against global watchlists (OFAC, EU, UN).</p>
      </div>
      <div className="pg-legal-section">
        <h2>4. Regulatory Framework</h2>
        <p>PRA Group operates under the regulatory frameworks applicable to our jurisdictions of operation. We actively engage with regulators and adapt our compliance programs as rules evolve in the digital asset space.</p>
        <p>We conduct periodic internal audits and engage independent third-party firms for annual compliance reviews.</p>
      </div>
      <div className="pg-legal-section">
        <h2>5. Data Protection</h2>
        <p>We comply with major data protection regulations including the General Data Protection Regulation (GDPR) for EU/EEA users, the California Consumer Privacy Act (CCPA) where applicable, and equivalent local data protection laws in jurisdictions where we operate.</p>
        <p>Our Data Protection Officer oversees compliance and can be reached at <strong>dpo@cryptovault.exchange</strong>.</p>
      </div>
      <div className="pg-legal-section">
        <h2>6. Sanctions Compliance</h2>
        <p>PRA Group screens all users and transactions against international sanctions lists. We do not provide services to individuals or entities located in sanctioned jurisdictions, or to anyone on designated sanctions lists.</p>
        <p>Attempted transactions involving sanctioned parties are automatically blocked and reported to the appropriate authorities.</p>
      </div>
      <div className="pg-legal-section">
        <h2>7. Reporting &amp; Transparency</h2>
        <p>We maintain transparent records and cooperate with regulatory investigations and lawful information requests. Users may be notified of data disclosures unless prohibited by law or court order.</p>
      </div>
      <div className="pg-legal-section">
        <h2>8. Whistleblower Protection</h2>
        <p>PRA Group maintains a confidential reporting channel for employees, contractors, and users to report suspected compliance violations. All reports are investigated promptly, and whistleblowers are protected from retaliation.</p>
        <p>Reports can be submitted to <strong>compliance@cryptovault.exchange</strong>.</p>
      </div>
      <div className="pg-legal-section">
        <h2>9. Contact</h2>
        <p>For compliance-related inquiries, contact our Compliance team at <strong>compliance@cryptovault.exchange</strong>.</p>
      </div>
    </PragroupLegal>
  );
}
